<template>
  <div class="contracts-register-list">
    <collapse v-model="opened" accordion>
      <panel v-for="(project, i) in projects" :key="project.id" :name="`${i}`">
        <contracts-register-row :project="project" :index="i" />
        <contract-table
          slot="content"
          :project="project"
        />
      </panel>
    </collapse>
  </div>
</template>

<script>
import ContractsRegisterRow from './contracts-register-row'
import ContractTable from './contract-table'

export default {
  props: ['projects', 'default-opened'],
  components: {
    ContractsRegisterRow,
    ContractTable
  },
  data () {
    return {
      opened: this.defaultOpened || []
    }
  },
  methods: {
    updateTable () {
      this.$emit('update-table')
    }
  }
}
</script>

<style lang="less">
.contracts-register-list {
  .ivu-collapse {
    &-header {
      display: flex;
      align-items: center;
    }
  }
}
.light {
  .contracts-register-list {
    .ivu-collapse {
      background-color: rgba(67, 82, 109, 0.04);
    }
  }
}
</style>
